import { Modal } from 'antd'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PerButton from '../../../../components/custom_components/Button'
import PerButtonCircle from '../../../../components/custom_components/ButtonCircle'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerIcon from '../../../../components/custom_components/Icon'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerText from '../../../../components/custom_components/Text'
import { CompanyRankingSettingsDto, Country } from '../../../../types'
import { CompanySettingsRankingTopTagProcessModalFooter } from './CompanySettingsRankingTopTagProcessModalFooter'

interface ICompanySettingsRankingTopTagProcessProps {
  companyId: string
  country: Country
  label: string
  settings: CompanyRankingSettingsDto
  disabled: boolean
}

export const CompanySettingsRankingTopTagProcess: FC<ICompanySettingsRankingTopTagProcessProps> = ({
  companyId,
  country,
  label,
  settings,
  disabled,
}) => {
  const { t } = useTranslation()

  const [showModal, toggleModal] = useState<boolean>(false)

  return (
    <>
      <PerFlexRow align="middle" justify="center" direction="column" className="per-infoBox--tagElement">
        <PerText appearance="label-small" align="center" mb={!!settings.tagAssignmentIsInProgress ? 'l' : 'xxs'}>
          {label}
        </PerText>
        {!settings.tagAssignmentIsInProgress && (
          <PerButton
            text={t('companySettingsView.rankingTab.settings.start')}
            color="primary"
            variant="pastel"
            testid="csr-modal-open"
            disabled={disabled}
            tooltip={
              disabled && (
                <PerText fontSize="s" align="left" mb="xxs">
                  {t('companySettingsView.rankingTab.settings.topPercentageTooltip')}
                </PerText>
              )
            }
            onClick={() => toggleModal(true)}
          />
        )}
        {!!settings.tagAssignmentIsInProgress && (
          <div style={{ position: 'relative', top: '-4px' }}>
            <PerFlexRow align="middle" justify="center">
              <PerIcon name="waiting_stroke" color="primary" size={16} variant="decoration" />
              <PerSpacer ml="xxxxs" mr="xxxxs" />
              <PerText appearance="label-small" color="primary" align="center" fontWeight="normal">
                {t('companySettingsView.rankingTab.settings.inProgress')}
              </PerText>
            </PerFlexRow>
          </div>
        )}
      </PerFlexRow>
      <Modal
        title={
          <PerFlexRow align="middle" justify="space-between">
            <PerText fontSize="xl" color="primary">
              {t('companySettingsView.rankingTab.modal.header')}
            </PerText>
            <PerButtonCircle
              size="large"
              icon="close_stroke"
              color="transparent"
              onClick={() => toggleModal(false)}
              testid="csr-modal-close"
            />
          </PerFlexRow>
        }
        visible={showModal}
        closable={false}
        bodyStyle={{ overflowY: 'auto', paddingBottom: '5px' }}
        footer={<CompanySettingsRankingTopTagProcessModalFooter companyId={companyId} country={country} toggleModal={toggleModal} />}
        destroyOnClose={true}
        className="per-modal per-modal--large"
      >
        <PerText>{t('companySettingsView.rankingTab.modal.description')}</PerText>
        <PerText mt="m">{t('companySettingsView.rankingTab.modal.confirmation')}</PerText>
      </Modal>
    </>
  )
}
